import { useEffect } from 'react'


const Lottery = ({ payload }) => {
    
    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")

            console.log(JSON.stringify(payload))
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])


    return (
        <>
            <header className="Screen__Questions">
                <p className="Screen__Questions__Header">Únete a la dinámica ingresando a DORADOSFC.APP</p>
            </header>

            <section className="Screen__Questions Container-FullHeight">
                <div>
                    {payload.view === 6 && (
                        <>
                            <img src={payload.card.ImgPath} className="LogoADSL Screen__Questions__Logo" alt="Logo" />
                            <p className="Screen__Questions__Text">{payload.card.Text}</p>
                        </>
                    )}
                </div>
            </section>
            
            <footer className='container'>
                <p className='text-center FooterCredits'>Hecho con ♥ por Interaktia | 2026</p>
            </footer>
        </>
    )
}

export { Lottery };